import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=3d53aa53&scoped=true&lang=pug&"
import script from "./CustomInput.vue?vue&type=script&lang=js&"
export * from "./CustomInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=3d53aa53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53aa53",
  null
  
)

export default component.exports